import { PageSuiteTagUtils } from '@Modules/pagesuite_module';

export interface MNGAuthHelpersApi {
  hasContentTag: (targetTag: string) => boolean;
}

/**
 * Helpers meant to be called from outside the plugin (Engage rule sets, GTM,
 * inline site scripts) via `MNGAuth.Helpers`.
 */
export const Helpers: MNGAuthHelpersApi = {
  hasContentTag: (targetTag) => PageSuiteTagUtils.hasContentTag(targetTag),
};
